import React, { useState, useEffect } from "react";
import { Signup } from "../../Api/services/AuthServices"
import { FaUserAlt, FaPhoneAlt, FaEnvelope, FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../NavBar";

const SignupPage = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        fullName: "",
        contactNumber: "",
        email: "",
        password: "",
    });

    const [error, setError] = useState("");

   

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        // Add validation logic if needed
        if (!formData.fullName || !formData.contactNumber || !formData.email || !formData.password) {
            setError("All fields are required.");
            return;
        }
        setLoading(true);

        try {
            const res = await Signup(formData);
            console.log(res);
            setFormData({ fullName: "", contactNumber: "", email: "", password: "" });
        } catch (err) {
            console.error(err);
            setError("An error occurred while signing up. Please try again.");
        }
        setLoading(false)
    };

    return (
        <>
            <Navbar />
            <div className="flex items-center justify-center min-h-[80vh] bg-gray-100">
            <div className="relative w-full max-w-lg bg-white shadow-lg p-8 rounded-lg">
                <h2 className="text-2xl font-bold text-center mb-6">Create Account</h2>

                <form onSubmit={handleSubmit} className="w-full p-4">
                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaUserAlt className="text-gray-500" />
                            </span>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                placeholder="Full Name"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaPhoneAlt className="text-gray-500" />
                            </span>
                            <input
                                type="text"
                                name="contactNumber"
                                value={formData.contactNumber}
                                onChange={handleChange}
                                placeholder="Contact Number"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaEnvelope className="text-gray-500" />
                            </span>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaLock className="text-gray-500" />
                            </span>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Password"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="mb-4 text-red-500 text-sm">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`w-full bg-blac k text-white py-3 rounded-md shadow-md bg-gray-900 focus:ring-2 focus:ring-blue-500 focus:outline-none ${loading ? "cursor-not-allowed" : ""}`}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "SIGN UP"}
                    </button>

                    <div className="mt-6 text-center text-gray-600">
                        Already have an account?{" "}
                        <Link
                            to="/login" 
                            className="text-black font-semibold hover:underline transition-all"
                        >
                            Log in
                        </Link>
                    </div>
                </form>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default SignupPage;
